import { Injectable, OnDestroy } from '@angular/core';
import {
  ResolveStart,
  Router,
  ActivatedRoute,
  NavigationEnd,
} from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class HeadBarService implements OnDestroy {
  public currentHeadBarTitle = 'Fit a Coach';

  public routeBackButtonCallback: (() => void) | null = null;

  private routeSubscription: Subscription;

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly activatedRoute: ActivatedRoute
  ) {
    // Handle initial route
    this.updateTitleFromCurrentRoute();

    // Handle subsequent route changes
    this.routeSubscription = this.router.events
      .pipe(
        filter(
          event =>
            event instanceof ResolveStart || event instanceof NavigationEnd
        ),
        map(event => {
          let data: any = null;
          let route: any = null;

          if (event instanceof ResolveStart) {
            route = event['state'].root;
          } else if (event instanceof NavigationEnd) {
            // Update from current route on NavigationEnd
            this.updateTitleFromCurrentRoute();
            return null;
          }

          while (route) {
            data = route.data || data;
            route = route.firstChild;
          }

          return data;
        }),
        filter(data => !!data)
      )
      .subscribe((routeData: any) => {
        this.currentHeadBarTitle = routeData['headBarTitle'] || 'Fit a Coach';
        this.routeBackButtonCallback = null;
      });
  }

  private updateTitleFromCurrentRoute(): void {
    let route: ActivatedRoute | null = this.activatedRoute;
    let data = {};

    while (route) {
      data = { ...data, ...route.snapshot.data };
      route = route.firstChild;
    }

    this.currentHeadBarTitle = data['headBarTitle'] || 'Fit a Coach';
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
  }
}
